export default __webpack_public_path__ + "static/media/settings-btn.1b17106d.svg";